import { ILatestBadgesItem } from "@ascendnow/shared";
import classNames from "classnames";
import Image from "next/image";

import AscBadge from "../../AscBadge/AscBadge";
import AscLink from "../../AscLink/AscLink";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import CertificateBadge from "../../../assets/illustrations/certificate-badge2.svg";
import { ReactComponent as ModalIconDecor } from "../../../assets/illustrations/modal-icon-decor.svg";
import AscImage from "../../AscImage/AscImage";
import styles from "./AscBadgesListCard.module.scss";

export interface AscBadgesListCardProps {
  title: string;
  badges: ILatestBadgesItem[];
  className?: string;
  seeAllText?: string;
  seeAllLinkUrl?: string;
  loading?: boolean;
}

export default function AscBadgesListCard({
  title,
  badges,
  className,
  loading = false,
  seeAllText = "See all",
  seeAllLinkUrl = "#",
}: AscBadgesListCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      bodyClassName={styles.body}
      contentClassName={badges?.length > 0 ? styles.content : ""}
      title={
        <div className={styles.header}>
          <h5 className={classNames(styles.headerTitle)}>{title}</h5>
          <AscLink
            className={styles.headerLink}
            showIcon
            href={seeAllLinkUrl}
            innerWrapperTag="button"
          >
            {seeAllText}
          </AscLink>
        </div>
      }
      coverImageUrl={null}
      loading={loading}
    >
      {badges?.length > 0 ? (
        badges?.map((badge) =>
          badge?.badge?.location ? (
            <AscImage
              className={classNames(styles.badgeImage, {
                [styles.badgeEarned]: !!badge?.earnedAt,
              })}
              src={badge?.badge?.location || ""}
              key={badge?.skillOrdCardId}
            />
          ) : (
            <AscBadge
              color={badge?.color}
              data-testid={`asc-badge-list-card-${badge?.skillOrdCardId}-badge`}
              className={classNames(styles.badge, {
                [styles.badgeEarned]: !!badge?.earnedAt,
              })}
              key={badge?.skillOrdCardId}
            />
          )
        )
      ) : (
        <div className={styles.empty}>
          <div className={styles.iconWrapper} style={{ marginTop: "1rem" }}>
            <ModalIconDecor />
            <Image
              src={CertificateBadge}
              alt="certificate-badge-icon"
              width={64}
              height={64}
            />
          </div>
          <span className={styles.emptyTitle}>No badges</span>
          <span className={styles.emptySubtitle}>
            You do not currently have a badge. Go through the modules to get
            your first badge!
          </span>
        </div>
      )}
    </AscGenericCard>
  );
}
